// removed by extract-text-webpack-plugin
module.exports = {"desktop":"1366px","large":"1600px","extra-large":"1920px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/SecondLevel.css
// module id = 800
// module chunks = 0